import {createSlice, PayloadAction} from "@reduxjs/toolkit";


import {GetDeletedSubjects, GetSubjects} from "./thunk";
import {IInitialStateSubjectsState, ISubjectPayload} from "../types";

const initialState:IInitialStateSubjectsState = {
    subjectsData:[],
    isLoadingSubjects:false,
    isViewSubjectsRestore:false,
    subjectsRestoreData:[],
    selectedSubjectsIDs:[],
    filteredSubject:[]
}


const subjectSlice = createSlice({
    name:"subjects",
    initialState,
    reducers:{
        setSubjectsData: (
            state,
            action: PayloadAction<{ data: ISubjectPayload[]; defaultLanguage: string }>
        ) => {
            const { data, defaultLanguage } = action.payload;
            state.subjectsData = data;

            state.filteredSubject = data.flatMap(({ id, translations, child_subjects }) => [
                ...translations
                    .filter(t => t.slug === defaultLanguage && t.name)
                    .map(t => ({
                        id,
                        name: t.name as string,
                        abbreviation: t.abbreviation ?? "",
                        isChild: false,
                    })),
                ...(child_subjects ?? []).flatMap(({ id: childId, translations }) =>
                    translations
                        .filter(t => t.slug === defaultLanguage && t.name)
                        .map(t => ({
                            id: childId,
                            name: t.name as string,
                            abbreviation: t.abbreviation ?? "",
                            isChild: true,
                        }))
                ),
            ]);
        },

        updateSubjects: (
            state,
            action: PayloadAction<ISubjectPayload>
        ) => {
            const updateData = action.payload;

            state.subjectsData = state.subjectsData.map(
                (elem) => {
                    if (elem.id === updateData.id) {
                        return {
                            ...elem,
                            ...updateData,
                        };
                    }
                    return elem;
                }
            );
        },
        deletedSubjects: (state, action: PayloadAction<number>) => {
            state.subjectsData = state.subjectsData.filter(
                (elem) => elem.id !== action.payload
            );

        },
        setSubjectsRestoreData:(state, action) => {
            state.subjectsRestoreData = action.payload;
        },
        setIsViewSubjectsRestore:(state)=>{

            state.isViewSubjectsRestore =!state.isViewSubjectsRestore;
        },
        setSelectedSubjectsIDs: (state, action) => {
            state.selectedSubjectsIDs=action.payload
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(GetSubjects.pending, (state) => {
                state.isLoadingSubjects = true;
            })
            .addCase(
                GetSubjects.fulfilled,
                (state,) => {
                    state.isLoadingSubjects = false;

                }
            )
            .addCase(GetSubjects.rejected, (state) => {
                state.isLoadingSubjects = false;
            })

            .addCase(GetDeletedSubjects.pending, (state) => {
                state.isLoadingSubjects = true;
            })
            .addCase(
                GetDeletedSubjects.fulfilled,
                (state) => {
                    state.isLoadingSubjects = false;

                }
            )
            .addCase(GetDeletedSubjects.rejected, (state) => {
                state.isLoadingSubjects = false;
            });

    },
})


export const {
    setSubjectsData,
    updateSubjects,
    deletedSubjects,
    setSelectedSubjectsIDs,
    setIsViewSubjectsRestore,
    setSubjectsRestoreData
} = subjectSlice.actions

export default  subjectSlice